import { VisibilityOff } from '@mui/icons-material'
import { Box, MenuItem, TextField, Typography } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
  }
}

type AppProps = StateProps & DispatchProps

const SecuritySettingsFC: React.FC<AppProps> = props => {
  const [privacy, setPrivacy] = React.useState('Public')
  const privacyOptions = ['Public', 'Private']

  return (
    <Box display={'flex'} flexDirection={'column'} padding={2}>
      <Box display={'flex'} flexDirection={'column'} minWidth={590} padding={2}>
        <Box borderBottom={1} paddingY={1} marginY={1}>
          <Typography variant={'h4'}>Change password</Typography>
        </Box>
        <Box display={'flex'} alignItems={'center'} padding={1}>
          <Typography variant={'h6'} flexGrow={1} width={0.5}>
            Current password:{' '}
          </Typography>
          <TextField
            InputProps={{ startAdornment: <VisibilityOff /> }}
            type={'password'}
            sx={{ width: 0.5 }}
          />
        </Box>
        <Box display={'flex'} alignItems={'center'} padding={1}>
          <Typography variant={'h6'} flexGrow={1} width={0.5}>
            New password:{' '}
          </Typography>
          <TextField
            InputProps={{ startAdornment: <VisibilityOff /> }}
            type={'password'}
            sx={{ width: 0.5 }}
          />
        </Box>
        <Box borderBottom={1} paddingY={1} marginY={1} paddingTop={3}>
          <Typography variant={'h4'}>Change e-mail</Typography>
        </Box>
        <Box display={'flex'} alignItems={'center'} padding={1}>
          <Typography variant={'h6'} flexGrow={1} width={0.5}>
            Current password:{' '}
          </Typography>
          <TextField
            InputProps={{ startAdornment: <VisibilityOff /> }}
            type={'password'}
            sx={{ width: 0.5 }}
          />
        </Box>
        <Box display={'flex'} alignItems={'center'} padding={1}>
          <Typography variant={'h6'} width={0.5}>
            New e-mail:{' '}
          </Typography>
          <TextField type={'email'} sx={{ width: 0.5, flexGrow: 1 }} />
        </Box>
        <Box borderBottom={1} paddingY={1} marginY={1} paddingTop={3}>
          <Typography variant={'h4'}>Privacy settings</Typography>
        </Box>
        <Box display={'flex'} alignItems={'center'} padding={1}>
          <Typography variant={'h6'} flexGrow={1} width={0.5}>
            Profile visibility:{' '}
          </Typography>
          <TextField
            type={'text'}
            select
            sx={{ width: 0.5 }}
            value={privacy}
            onChange={event => {
              setPrivacy(event.target.value)
            }}
          >
            {privacyOptions.map(option => (
              <MenuItem value={option} key={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </Box>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations
})

const SecuritySettings = connect(
  mapStateToProps,
  mapDispatchToProps
)(SecuritySettingsFC)

export default SecuritySettings
